import React from 'react'
import { styled } from "../../../stitches.config";

import { ImageCaption } from '../../../components/Article/Parts/BackgroundImage';
import { withDrawingBoard } from "../../../components/HOCs/withDrawingBoard"

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

const ImageAnimated = ({ blockData, ...props }) => {
    const srcUrl = blockData.url.replace("0,0,0,0", "700,0,0,0");
    return (
        <AnimationOnScroll duration={blockData.duration} animateOnce={true} animateIn={blockData.direction}>
            <BizonImageWrapper>
                <img src={srcUrl} alt="" onLoad={() => props.updateHeight()} />
                {blockData.imageCaption !== "" && <ImageCaption className="image-caption">{blockData.imageCaption}</ImageCaption>}
            </BizonImageWrapper>
        </AnimationOnScroll>
    )
}

const BizonImageWrapper = styled("div",{
    width: "100%",
    margin: "40px auto 32px auto",
    "img":{
        width: "100%",
        height: "auto"
    },
    "@bp4":{
        width: "840px",
        margin: "88px auto 88px auto"
    },
    ".image-caption": {
        marginTop: "8px",
        fontStyle: "normal",
        textAlign: "center",
        color: "$grayscale75",
        fontSize: "14px",
        lineHeight: "18px",
        fontFamily: "$grotesk",
        "@bp4":{
            marginTop: "12px"
        }
    }
});

export default withDrawingBoard(props => props.blockData.hasCanvas)(ImageAnimated);